import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export enum InLineSeverity {
  critical = 'critical',
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export const InLineSeveritySelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.InLineSeverity}-${InLineSeverity.critical}`,
    value: InLineSeverity.critical,
    displayName: 'Critical',
    filterType: FilterTypesEnum.InLineSeverity,
    categoryName: FilterTypesEnum.InLineSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.InLineSeverity}-${InLineSeverity.high}`,
    value: InLineSeverity.high,
    displayName: 'High',
    filterType: FilterTypesEnum.InLineSeverity,
    categoryName: FilterTypesEnum.InLineSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.InLineSeverity}-${InLineSeverity.medium}`,
    value: InLineSeverity.medium,
    displayName: 'Medium',
    filterType: FilterTypesEnum.InLineSeverity,
    categoryName: FilterTypesEnum.InLineSeverity.toString(),
  },
  {
    id: `${FilterTypesEnum.InLineSeverity}-${InLineSeverity.low}`,
    value: InLineSeverity.low,
    displayName: 'Low',
    filterType: FilterTypesEnum.InLineSeverity,
    categoryName: FilterTypesEnum.InLineSeverity.toString(),
  },
];
